<template>

    <main class="gmp-page gmp-page--no-newsletter">

        <GOODS_scondHero />
        <GOODS_highLights :clientWidth="clientWidth"/>
        <GOODS_twoTout />

        <div>Distributor</div>

    </main>

</template>


<script>
    import GOODS_scondHero from "../../components/content/market/overView/GOODS_scondHero";
    import GOODS_highLights from "../../components/content/market/overView/GOODS_highLights";
    import GOODS_twoTout from "../../components/content/market/overView/GOODS_twoTout";


    export default {
        name: 'Goods',
        components: {
            GOODS_scondHero,
            GOODS_highLights,
            GOODS_twoTout,
        },
        data() {
            return {
                clientWidth: "",
            }
        },

        mounted() {

            this.clientWidth = `${document.documentElement.clientWidth}`          //document.body.clientWidth;
            const that = this
            window.onresize = () => {
                return (() => {
                    window.screenWidth = document.body.clientWidth
                    that.clientWidth = window.screenWidth
                })()
            }

        },
        methods: {

        }

    }
</script>

<style>


</style>
